type ConversionEvent = {
    event: string;
    formName: string;
}

$(document).on('submit', '[name=formQueroVenderCondominio]', function () {
    var $self = $(this);
    if ($self.data('enviando')) return false;
    var $button = $self.find('[type=submit]') as JQuery<HTMLButtonElement>;
    if (!$button.data('default-value')) {
        $button.data('default-value', $button.html() || '');
    }


    $self.data('enviando', true);
    //$.fancybox.showLoading();
    $button.html('Enviando...');

    var callback = function (resp: any) {
        if (resp.redirect_url != undefined) {
            location.href = resp.redirect_url;
            return;
        }
        $self.data('enviando', false);
        //$.fancybox.hideLoading();
        $button.val($button.data('default-value'));

        //if (cb) return cb(resp, $self);

        if (resp.success) {
            /** @ts-ignore */
            window.dataLayer = window.dataLayer || []

          
            let values: ConversionEvent = {
                event: 'formConversion',
                formName: ''
            }
            $self.find('input').each(function () {
                let $el = $(this)
                let name = $el.attr('name') || ''
                let value = $el.val()

                if ('' !== name && 'recaptcha_token' !== name) {
                    values[name as keyof ConversionEvent] = value as string;
                }
            })

            let formName = $self.attr('name') || ''
            if ('' !== formName) {
                values.formName = formName
            }

            /** @ts-ignore */
            window.dataLayer.push(values)
            /** @ts-ignore */
            console.table(window.dataLayer)
        }

        alert(resp.msg);
        if (resp.success) {
            $self[0].reset();
            $self.find('[alt=phone]').val('');



            if (resp.redirect_url != undefined) {
                location.href = resp.redirect_url;
            } else {

                location.reload();
            }


        }
    }

    const send = function () {
        $.ajax({
            url: $self.attr('action') + '?t=' + Date.now(),
            type: 'post',
            dataType: 'json',
            data: $self.serializeArray(),
            success: callback,
            error: function () {
                callback({ success: false, msg: "Não foi possível enviar o formulário." });
            }
        });
    }



    /** @ts-ignore */
    if (window.recaptcha_site_key) {
        /** @ts-ignore */
        grecaptcha.ready(function () {
            /** @ts-ignore */
            grecaptcha.execute(window.recaptcha_site_key, { action: 'submit' }).then(function (token: string) {
                $self.find('[name=recaptcha_token]').remove()
                $self.append('<input type="hidden" name="recaptcha_token" />')
                $self.find('[name=recaptcha_token]').val(token)

                send()
            })
        })
    } else {
        send()
    }



    return false;
})